var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4584_55364)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 0.5)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.77684 1.33398C6.31014 1.33398 5.88834 1.61212 5.7045 2.04108L5.00754 3.66732H3.0084H3.00035H2.00391C1.72776 3.66732 1.50391 3.89118 1.50391 4.16732C1.50391 4.44346 1.72776 4.66732 2.00391 4.66732H2.53329L3.09557 13.9449C3.15422 14.9125 3.95609 15.6673 4.92555 15.6673H11.0822C12.0517 15.6673 12.8536 14.9125 12.9123 13.9449L12.9123 13.9449L13.4745 4.66732H14.0039C14.28 4.66732 14.5039 4.44346 14.5039 4.16732C14.5039 3.89118 14.28 3.66732 14.0039 3.66732H13.0075H12.9994H11.0003L10.3033 2.04107C10.1195 1.61205 9.69758 1.33398 9.23097 1.33398H6.77684ZM12.4727 4.66732H3.53513L4.09374 13.8844C4.1204 14.3242 4.48489 14.6673 4.92555 14.6673H11.0822C11.5229 14.6673 11.8874 14.3242 11.9141 13.8844L11.9141 13.8844L12.4727 4.66732ZM9.91229 3.66732H6.09551L6.62365 2.435C6.64991 2.37372 6.71017 2.33398 6.77684 2.33398H9.23097C9.29767 2.33398 9.35793 2.37384 9.38414 2.435L9.91229 3.66732ZM6.33724 7.00065C6.61338 7.00065 6.83724 7.22451 6.83724 7.50065V11.5007C6.83724 11.7768 6.61338 12.0007 6.33724 12.0007C6.0611 12.0007 5.83724 11.7768 5.83724 11.5007V7.50065C5.83724 7.22451 6.0611 7.00065 6.33724 7.00065ZM10.1706 7.50065C10.1706 7.22451 9.94672 7.00065 9.67057 7.00065C9.39443 7.00065 9.17057 7.22451 9.17057 7.50065V11.5007C9.17057 11.7768 9.39443 12.0007 9.67057 12.0007C9.94672 12.0007 10.1706 11.7768 10.1706 11.5007V7.50065Z",
    fill: "#76B72A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4584_55364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic-delete.b2b6355e3ff4f8d0102b84203e91c473.svg";
export { ForwardRef as ReactComponent };